module.exports = __webpack_public_path__ + "static/media/S4N9-5.126e2835.svg";